const PAYLOAD_KEY = 'ton_proof_payload'

export interface StoredPayload {
  payload: string
  payloadToken: string
  timestamp: number
}

/**
 * Save TON proof payload to localStorage
 */
export const savePayload = (payload: string, payloadToken: string): void => {
  try {
    const data: StoredPayload = {
      payload,
      payloadToken,
      timestamp: Date.now(),
    }
    localStorage.setItem(PAYLOAD_KEY, JSON.stringify(data))
  } catch (error) {
    throw new Error(`Authentication: Failed to save payload: ${error}`)
  }
}

/**
 * Get stored TON proof payload from localStorage
 * Returns null if payload is expired (older than 10 minutes)
 */
export const getStoredPayload = (): StoredPayload | null => {
  try {
    const stored = localStorage.getItem(PAYLOAD_KEY)
    if (!stored) return null

    const data: StoredPayload = JSON.parse(stored)

    // Check if payload is expired (10 minutes)
    const TEN_MINUTES = 10 * 60 * 1000
    if (Date.now() - data.timestamp > TEN_MINUTES) {
      removePayload()
      return null
    }

    return data
  } catch (error) {
    throw new Error(`Authentication: Failed to get stored payload: ${error}`)
  }
}

/**
 * Remove payload from localStorage
 */
export const removePayload = (): void => {
  try {
    localStorage.removeItem(PAYLOAD_KEY)
  } catch (error) {
    throw new Error(`Authentication: Failed to remove payload: ${error}`)
  }
}
